import { ComponentChildren, h } from 'preact'
import Icon from '../assets'

interface Props {
  isActive: boolean
  title?: string
  children?: ComponentChildren
  togglePanel: (isActive: boolean) => void
}

export const ConfigurationPanel = ({ isActive, title, children, togglePanel }: Props) => {
  return (
    <div className='widget-configurator_tabs-wrapper'>
      <div className='widget-configurator_tab homepage-widget-configurator_tab-template'>
        <div className='widget-configurator_tab-header' onClick={() => togglePanel(isActive)}>
          <div className='widget-configurator_tab-icon'>
            {
              isActive
                ? (
                  <Icon size={24} color='#2B3346' icon='chevronDown' />
                  )
                : <Icon size={24} color='#2B3346' icon='chevronRight' />
            }
          </div>
          <span className='widget-configurator_tab-title'>{title}</span>
        </div>
        {
          isActive
            ? (
              <div className='widget-configurator_tab-content'>
                {children}
              </div>
              )
            : null
        }
      </div>
    </div>
  )
}
